<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 sm6 row>
        <v-dialog v-model="showOpenDoorEntryDialog" persistent max-width="290" style="display: block">
          <v-btn href="#" color="red lighten-1" block slot="activator" class="white--text capitalize" v-html="$t('private_parking_activity_button_open')"></v-btn>
          <v-card>
            <v-card-title class="headline">{{ $t('global_label_warning') }}</v-card-title>
            <v-card-text>{{ $t('open_door_warning_message') }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" flat @click.native="showOpenDoorEntryDialog = false">{{ $t('button_cancel') }}</v-btn>
              <v-btn color="primary" flat :loading="isOpeningDoor" :disabled="isOpeningDoor" @click.native="openDoorEntry"
                >{{ $t('button_accept') }}
                <span slot="loader" class="custom-loader">
                  <v-icon light>cached</v-icon>
                </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex xs12 sm6 row>
        <v-dialog v-model="showOpenDoorExitDialog" persistent max-width="290" style="display: block">
          <v-btn href="#" color="red lighten-1" block slot="activator" class="white--text capitalize" v-html="$t('private_parking_activity_button_close')"></v-btn>
          <v-card>
            <v-card-title class="headline">{{ $t('global_label_warning') }}</v-card-title>
            <v-card-text>{{ $t('open_door_warning_message') }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" flat @click.native="showOpenDoorExitDialog = false">{{ $t('button_cancel') }}</v-btn>
              <v-btn color="primary" flat :loading="isOpeningExitDoor" :disabled="isOpeningExitDoor" @click.native="openDoorExit"
                >{{ $t('button_accept') }}
                <span slot="loader" class="custom-loader">
                  <v-icon light>cached</v-icon>
                </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import doorService from '@/services/doorService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'activity-action-buttons',
  props: ['parkingId'],
  data() {
    return {
      showOpenDoorEntryDialog: false,
      showOpenDoorExitDialog: false,
      isOpeningDoor: false,
      isOpeningExitDoor: false
    };
  },
  methods: {
    openDoorEntry() {
      this.isOpeningDoor = true;
      let params = {
        parking: this.parkingId
      };
      doorService.openDoorEntry(params, this.openDoorEntrySuccessHandler, this.openDoorEntryErrorHandler);
    },
    openDoorEntrySuccessHandler(data) {
      if (data.message) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: data.message,
          type: 'accent',
          doNotTranslate: true
        });
      }
      this.showOpenDoorEntryDialog = false;
      this.isOpeningDoor = false;
    },
    openDoorEntryErrorHandler(error) {
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: error,
        type: 'error',
        doNotTranslate: true
      });

      this.showOpenDoorEntryDialog = false;
      this.isOpeningDoor = false;
    },
    openDoorExit() {
      this.isOpeningExitDoor = true;
      let params = {
        parking: this.parkingId
      };
      doorService.openDoorExit(params, this.openDoorExitSuccessHandler, this.openDoorExitErrorHandler);
    },
    openDoorExitSuccessHandler(data) {
      if (data.message) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: data.message,
          type: 'accent',
          doNotTranslate: true
        });
      }
      this.isOpeningExitDoor = false;
      this.showOpenDoorExitDialog = false;
    },
    openDoorExitErrorHandler(error) {
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: error,
        type: 'error',
        doNotTranslate: true
      });

      this.isOpeningExitDoor = false;
      this.showOpenDoorExitDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ActivityActionButtons.vue